import React, { createContext, useContext } from "react";
import { NativeInvoiceFormState } from "./nativeInvoiceFormTypes";

interface NativeInvoiceFormContextValue {
    state: NativeInvoiceFormState;
    setState: React.Dispatch<React.SetStateAction<NativeInvoiceFormState>>;
}

export const NativeInvoiceFormContext =
    createContext<NativeInvoiceFormContextValue | null>(null);

export function useNativeInvoiceFormContext(): NativeInvoiceFormContextValue {
    const context = useContext(NativeInvoiceFormContext);
    if (context === null) {
        throw new Error(
            "useNativeInvoiceFormContext must be used within a NativeInvoiceFormProvider",
        );
    }
    return context;
}
